/**
 * Application Configuration
 */

const configuration = {
    CLIENT_STORAGE_KEYS: {
        USER_STORAGE_KEY: 'td-atom-admin-v1',
        TOKEN_STORAGE_KEY: 'td-atom-admin-token-v1',
        GOOGLE_ACCESS_TOKEN: 'googleAuthToken',
    },
};

export default configuration;
